<div class="generic-content-container">
	<h3 class="generic-content-title text-center">
		{{ contentTitle }}
	</h3>
	<div class="generic-content__body">
		<ng-content></ng-content>
	</div>
	<button class="btn btn-cta block" (click)="onClick()">
		{{ btnText }}
	</button>
</div>
